import { render } from "./LibSvg.vue?vue&type=template&id=d223d304"
import script from "./LibSvg.vue?vue&type=script&lang=js"
export * from "./LibSvg.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__